
<div *ngFor="let task of this.outcomeTasks">
    <h4>{{task.nodeName}}</h4>
    <div class="row">
        <!-- Loop -->
        <div class="col-12 col-lg-6 col-xl-3 iQcard_col" *ngFor="let subtask of task['tasks']">
            <div class="card iQcard item-hover-effect">
                <div class="iQcard_header">
                  <div class="row">
                    <div class="col">
                      <div class="headerTitle">{{subtask['taskName']}}</div>
                    </div>
                    <div class="col-auto pl-0">
                    </div>
                  </div>
                </div>
                <div class="iQcard_body pt-0">
                  <div class="row">
                    <div class="col">
                      <p class="completedStatus" *ngIf="subtask['status']=='completed'"><b>{{subtask['status'].charAt(0).toUpperCase() + subtask['status'].slice(1)}}</b></p>
                    </div>
                    <div class="col-auto" *ngIf="subtask['status']=='edit'">
                      <k-button [type]="KButtonType.KLAiMSButton" [label]="'Edit'" [color]="'brand-main'"
                        (buttonClick)="taskAction(task,this.claimId)">
                      </k-button>
                    </div>
                    <div class="col-auto" *ngIf="subtask['status']=='todo'">
                      <k-button [type]="KButtonType.KLAiMSButton" [label]="'Initiate'" [color]="'brand-main'"
                        (buttonClick)="taskAction(task,this.claimId)">
                      </k-button>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <!-- Loop End -->
    </div>
</div>